export default "__VITE_ASSET__b19808e3__"